/**Tested list */
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import uiReducer from "./uiSlice";
//import enumReducer from "./enumSlice";
import admissionInformationReducer from "./AdmissionInformationSlice";

//import admissionReducer from "./admissionSlice";
//import newParentApplicationReducer from "./newParentsApplicationFormSlice";
//import existingParentApplicationReducer from "./ExistingParentApplicationEnquirySlice";
import applicationEnquiryReducer from "./ApplicationEnquirySlice";
import applicationFormDetailReducer from "./applicationFormDetailAllInOneSlice";
import enumReducer from "./enumSlice";

import gradesReducer from "./gradesSlice";
import dashboardReducer from "./dashboardSlice";
import admissionPeriodReducer from "./admissionPeriodSlice";
import pageAccessReducer from "./pageAccessSlice";
import studentDataReducer from "./PersonalBasicInfoSlice";
import staffDataReducer from "./StaffBasicInfoSlice";

import healthInfoSlice from "./healthInfoSlice";
import healthIssueSlice from "./healthIssueSlice";
import studentHistoryReducer from "./studentHistorySlice";
import whoIsTheUserReducer from "./WhoIsTheUserSlice"
import groupReducer from "./groupSlice.js";
import groupMembersReducer from "./groupMemberSlice.js";
import messageReducer from "./messageSlice.js";
import batchReducer from "./batchSlice";
import termReducer from "./termSlice";
import studentsReducer from "./studentsSlice.js";
import paymentsReducer from "./createPaymentSlice.js";
import schoolReducer from "./divisionSlice.js";
import academicCalendarReducer from "./academicCalendarFormSlice.js";
import periodReducer from "./periodManagementSlice";
import schoolDayReducer from "./schoolDaySlice";
import disciplinaryIncidentReducer from "./disciplinaryIncidentSlice.js";
import disciplinaryProblemsReducer from "./disciplinaryProblemTypeSlice.js";
import studentIDCardReducer from "./studentIDCardSlice.js";
import batchSectionReducer from "./batchSectionSlice";
import disciplinaryIncidentActionReducer from "./disciplinaryIncidentActionSlice.js";
import problemActionRelationReducer from "./problemActionRelationSlice.js";
import transcriptReducer from "./studentAcademicSlice.js";
import attendanceReducer from "./attendanceSlice.js";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    //    enums: enumReducer,
    admissionInformation: admissionInformationReducer,

    /* untested */
    //   admission: admissionReducer,
    //   newParentApplication: newParentApplicationReducer,
    //existingParentApplication: existingParentApplicationReducer,
    applicationEnquiry: applicationEnquiryReducer,
    enums: enumReducer,
    applicationFormDetail: applicationFormDetailReducer,
    //  parentApplication: parentApplicationReducer,
    admissionPeriod: admissionPeriodReducer,
    grades: gradesReducer,
    dashboard: dashboardReducer,
    pageAccess: pageAccessReducer,
    studentdata: studentDataReducer,
    staffData: staffDataReducer,

    healthInfo: healthInfoSlice,
    healthIssue: healthIssueSlice,
    studentHistory: studentHistoryReducer,
    whoIsTheUser: whoIsTheUserReducer,
    group: groupReducer,
    groupMembers: groupMembersReducer,
    message: messageReducer,
    batches: batchReducer,
    terms: termReducer,
    students: studentsReducer,
    payments: paymentsReducer,
    schools: schoolReducer,
    academicCalendar: academicCalendarReducer,
    periods: periodReducer,
    schoolDay: schoolDayReducer,
    disciplinaryIncident: disciplinaryIncidentReducer,
    disciplinaryProblems: disciplinaryProblemsReducer,
    studentIDCard: studentIDCardReducer,
    batchSections: batchSectionReducer,
    disciplinaryIncidentAction: disciplinaryIncidentActionReducer,
    problemActionRelation: problemActionRelationReducer,
    transcript: transcriptReducer,
attendance: attendanceReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(/* your middlewares */),
});

